module.exports = __webpack_public_path__ + "img/roboto-v20-latin-700.57888be7.svg";